export default __webpack_public_path__ + "static/media/winter2.615fa28e.jpg";